import { BubbleColor } from '../bubbles/types';
import { IGameData } from '../types';

export function getAvailableColors(gameData: IGameData): BubbleColor[] {
  const config = gameData.config.availableColors.reduce((prev, current) => {
    if (current.startSec < gameData.state.time) {
      return current;
    }
    return prev;
  });

  return Object.values(BubbleColor).slice(0, config.colors);
}

window.getAvailableColors = getAvailableColors;